var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import queryString from 'query-string';
import { getInitConfig } from 'ziphy-web-shared';
import { apiService, myackAxiosInstance } from 'ziphy-web-shared/basic/api';
import { APP_TYPE } from 'ziphy-web-shared/basic/helpers';
import { sessionStore } from 'ziphy-web-shared/basic/utils';
import { parseReferenceId } from '@modules/_LEGACY_/fhir/fhir.helpers';
import { getPsPatientId, getPsPracticeId } from '@ps/services/psService.helpers';
export function mediaAuthService({ patientId = getPsPatientId(), practiceId = getPsPracticeId(), } = {}) {
    const id = `mediaAuth.${[patientId, practiceId].filter((x) => x).join('_')}`;
    return {
        get(full = false) {
            const primary = sessionStore.get(id, {});
            const fallback = sessionStore.get('mediaAuth.__last', {});
            const hasPrimary = primary && primary.params && Object.keys(primary.params).length > 0;
            const result = hasPrimary ? primary : fallback;
            if (!full) {
                return result === null || result === void 0 ? void 0 : result.params;
            }
            return result;
        },
        set(params) {
            const payload = {
                date: Date.now() / 1000,
                timeout: 60 * 3,
                params,
            };
            sessionStore.set(id, payload);
            sessionStore.set('mediaAuth.__last', payload);
        },
        fetch(references = [], opts = {}) {
            return __awaiter(this, void 0, void 0, function* () {
                if (references.length && !checkIfNeedLoad(references)) {
                    return;
                }
                if (!opts.force && checkIfValid(this.get(true))) {
                    return;
                }
                const res = yield getMediaAuth({ patientId, practiceId });
                if (res) {
                    this.set(res);
                }
            });
        },
        getUrlWithAuth(url) {
            if (checkIfValid(this.get(true))) {
                const queryParams = this.get();
                if (_.isEmpty(queryParams))
                    return;
                return queryString.stringifyUrl({ url, query: queryParams });
            }
            return url;
        },
    };
}
// todo: use apiService from @services
function getMediaAuth({ patientId, practiceId, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const accessToken = yield apiService.getAccessToken();
        if (!accessToken)
            return false;
        let result;
        try {
            let params = {
                patient_id: patientId || getPsPatientId(),
                practice_id: practiceId || getPsPracticeId(),
            };
            const url = queryString.stringifyUrl({
                url: `${getInitConfig().apiService.urls.hooksUrl}/zmr/${APP_TYPE}/media/authorize`,
                query: params,
            });
            const response = yield myackAxiosInstance.get(url, {
                headers: { 'X-Access-Token': accessToken },
            });
            result = response === null || response === void 0 ? void 0 : response.data;
        }
        catch (e) { }
        return result;
    });
}
function checkIfNeedLoad(list = []) {
    let isFound = false;
    _.forEach(list, (x) => {
        if (['Media', 'DocumentReference'].includes(parseReferenceId(x).resource)) {
            isFound = true;
            return false;
        }
    });
    return isFound;
}
function checkIfValid(data) {
    const isNotExpired = Date.now() / 1000 - data.date < data.timeout;
    const hasParams = !_.isEmpty(data.params);
    return isNotExpired && hasParams;
}
